import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';
import { lineHeight, responsiveFontSize } from 'style';

const TextSectionComponent = ({ label, body }) => (
    <div className="wrapper" id="textSectionComponent">
    <div className="container-fluid">
        <div className="row">
            <Text className="col-xs-12">
                <div className="label">{label}</div>
                <div className="body">{body}</div>
            </Text>
        </div>
    </div>
    </div>
);

const Text = styled.div`
    .label {
        margin-bottom: 1.5em;
        font-weight: 700;
    }
    .body {
        ${responsiveFontSize(20, 37)};
        line-height: ${lineHeight(42, 28)};
    }
`;

export default TextSectionComponent;
